import { fetchRnaCatalog } from "./automated-pro/RnaCatalog";
import { fetchSecondaryIfCatalog } from "./secondary-if/SecondaryIfCatalog";
var MetaCatalog = /** @class */ (function () {
    function MetaCatalog(rnaCatalog, secondaryIfCatalog) {
        this.rnaCatalog = rnaCatalog;
        this.secondaryIfCatalog = secondaryIfCatalog;
    }
    return MetaCatalog;
}());
export { MetaCatalog };
var MetaCatalogLoader = /** @class */ (function () {
    function MetaCatalogLoader(mode, catalogType, userId, product) {
        this.mode = mode;
        this.catalogType = catalogType;
        this.userId = userId;
        this.product = product;
    }
    MetaCatalogLoader.prototype.load = function () {
        var rnaPromise = fetchRnaCatalog(this.mode, this.catalogType, this.userId, this.product);
        var ihcPromise = fetchSecondaryIfCatalog(this.mode);
        return Promise.all([rnaPromise, ihcPromise])
            .then(function (_a) {
            var rna = _a[0], ihc = _a[1];
            return new MetaCatalog(rna, ihc);
        });
    };
    return MetaCatalogLoader;
}());
export { MetaCatalogLoader };
//# sourceMappingURL=Catalog.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/Catalog.js
// module id = 46
// module chunks = 0